import { render, staticRenderFns } from "./TitleBanner.vue?vue&type=template&id=970a9e8c&"
import script from "./TitleBanner.vue?vue&type=script&lang=js&"
export * from "./TitleBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default})
